import { connect } from 'react-redux'
import { debounce } from 'lodash'
import { setClient } from '../../selection/actions'
import { setPrefill } from '../../offer/actions'
import { getOfferForm, getPrefill } from '../selectors'
import OfferForm from '../components/offerForm'

const mapStateToProps = state => ({
  form: getOfferForm(state),
  prefill: getPrefill(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setClient: (form) => {
    dispatch(setClient(form))
    ownProps.history.push('/angebot-angefordert')
  },
  setPrefill: debounce((form) => {
    dispatch(setPrefill(form))
  }, 100),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OfferForm)



// WEBPACK FOOTER //
// ./src/modules/offer/containers/offerForm.js